// De pensiontarieven van de vestiging: de prijscategorieën waaruit de balie per dier kiest, met de dagprijs die op de
// aankomstdatum geldt. Ze komen uit Producten › Pensiontarieven.
import { useCustom } from "@refinedev/core";

import { useLocatieUrl } from "./locatie";

import type { PensionDier } from "../pensionKlantTypes";
import { isDatum } from "./bouwstenen";

export interface Prijscategorie {
  id: number;
  naam: string;
  diersoortId: number | null;
  diersoort: string | null;
  bedrag: number | null;
  bedragHoog: number | null;
}

/** De tarieven van de vestiging op de peildatum; zonder geldige datum die van vandaag. */
export function usePrijscategorieen(peildatum: string): Prijscategorie[] {
  const locatie = useLocatieUrl();
  const data = useCustom<Prijscategorie[]>({
    url: locatie(`pension/prijscategorieen${isDatum(peildatum) ? `?peildatum=${peildatum}` : ""}`),
    method: "get",
  }).data?.data;
  return Array.isArray(data) ? data : [];
}

/** De tarieven die bij de diersoort van een dier horen; een tarief zonder diersoort geldt voor alle dieren. */
export function tarievenVoor(dier: Pick<PensionDier, "diersoort">, tarieven: Prijscategorie[]): Prijscategorie[] {
  const soort = (dier.diersoort ?? "").toLowerCase();
  return tarieven.filter((t) => t.diersoortId == null || (t.diersoort ?? "").toLowerCase() === soort);
}
